import React, { useState } from "react";
import { Col, Form, InputGroup, Row } from "react-bootstrap";
import AboutThisImport from "./AboutThisImport";
import ApiConnection from "./ApiConnection";
import NylasConnection from "./NylasConnection";
import Input from "../../Builder/nodes/Logic/Inputs/Input";
import timezones from "../../Builder/nodes/Logic/timezones";
import ProjectInputVariables from "../ProjectInputVariables";
import { pageProps } from "../../helpers/pageProps";
import MyModal from "../MyModal";
import {
  settingsProxyAPI,
  useLazyResetApiTokenQuery,
  useLazyResetMessagingApiPasswordQuery,
} from "../../store/slices/settingsSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import LogicOpenAPI from "./LogicOpenAPI";
import HelpButton from "../../HelpContent/HelpButton";
import { useConfirmDialog } from "../../Builder/Components/ConfirmDialogContext";

export default function Details({ api, onChange, backendErrors }) {
  const confirmDialog = useConfirmDialog();
  const [resetToken] = useLazyResetApiTokenQuery();
  const [resetMessagingPassword] = useLazyResetMessagingApiPasswordQuery();
  const [newPasswordData, setNewPasswordData] = useState();

  let dynamicHeaderValid = true;
  dynamicHeaderValid =
    dynamicHeaderValid && api.Messaging?.default_dynamic_header.length >= 3;
  dynamicHeaderValid =
    dynamicHeaderValid && api.Messaging?.default_dynamic_header.length <= 11;
  dynamicHeaderValid =
    dynamicHeaderValid &&
    /^[A-Za-z][A-Za-z0-9_ ]*$/.test(api.Messaging?.default_dynamic_header);

  return (
    <div>
      <Row className="mb-5 mt-3 m-5">
        <Col xs={12} lg={6} className="pe-3 border-end">
          <AboutThisImport
            api={api}
            onChange={onChange}
            backendErrors={backendErrors}
          />
        </Col>
        <Col xs={12} lg={6} className="ps-3">
          {api.Kind === "third-party" && (
            <ApiConnection
              api={api.Profile}
              onChange={(Profile) => onChange({ ...api, Profile })}
            />
          )}
          {api.Kind === "nylas" && (
            <div className="my-4">
              <NylasConnection api={api} onChange={onChange} />
              <div className="bg-purple-gradient-darker-reverse rounded-4 p-3">
                <h5 className="">Time zone for your calendar</h5>
                <Input
                  inputType="select"
                  onChange={([v]) => onChange({ TimeZone: v })}
                  value={[api.TimeZone]}
                  options={timezones.map((c) => ({
                    label: c.label,
                    value: c.tzCode,
                  }))}
                />
              </div>
            </div>
          )}

          {api.Kind === "logic" && (
            <>
              <div className="my-4">
                <div className="bg-purple-gradient-darker-reverse rounded-4 p-3">
                  <h5 className="">Authetication credentials</h5>
                  {api.Token ? (
                    <div className="mt-2">
                      <div>
                        <strong>X-Api-Token:</strong>{" "}
                        <span style={{ userSelect: "all" }}>{api.Token}</span>
                      </div>
                      <button
                        className="btn-colored rounded-pill border-0 px-2 mt-2"
                        onClick={async () => {
                          const res = await resetToken({ Uuid: api.Uuid });
                          console.log(res);
                          settingsProxyAPI.util.invalidateTags([
                            "ApiConnections",
                          ]);
                        }}
                      >
                        Reset token
                      </button>
                    </div>
                  ) : (
                    "Your credentials will be available once you save this API."
                  )}
                </div>
              </div>
              <div className="my-4">
                <div className="bg-purple-gradient-darker-reverse rounded-4 p-3">
                  <h5>
                    Example request headers:
                    <HelpButton helpKey="api-example-request-headers" />
                  </h5>
                  <pre>
                    <div>Content-Type: application/json </div>
                    <div>
                      X-Api-Token:{" "}
                      {api.Token || (
                        <em>
                          Your API Token will appear here once you save the API.
                        </em>
                      )}{" "}
                    </div>
                    <div>
                      X-Idempotency-Key: <em>your_ref</em>
                    </div>
                  </pre>
                  <div className="alert alert-secondary text-wrap mt-3 mb-0">
                    <strong>
                      The Idempotency Key gives you control over unintended
                      duplication of requests.
                    </strong>
                    <br />
                    Provide a unique string, and we will check whether the same
                    request has been made in the past (within the last 3 months)
                    or is currently ongoing. If a previous request exists, we
                    will return the original response.
                  </div>
                </div>
              </div>
              <div className="my-4">
                <div className="bg-purple-gradient-darker-reverse rounded-4 p-3">
                  <h5 className="">Connected projects</h5>
                  Your connected projects will appear here. Details of the
                  projects can be found in the next tab.
                  {api.Triggers?.length > 0 ? (
                    api.Triggers.map((t, idx) => (
                      <div
                        key={idx}
                        className="mt-3 bg-secondary bg-opacity-10 p-3 rounded-3"
                      >
                        <strong>
                          {t.Project?.Label || `Project ${idx + 1}`} -{" "}
                          <span className="badge bg-secondary">
                            {t.Project?.Status}
                          </span>
                        </strong>
                        <div className="text-secondary small mb-2">
                          {t.Method || "POST"}:{" "}
                          {api.Uuid ? (
                            <span style={{ userSelect: "all" }}>
                              {`${pageProps.inboundApiBase}/${api.Uuid}/${t.Reference}`}
                            </span>
                          ) : (
                            <em>
                              Your API endpoint will appear here once you save
                              the API.
                            </em>
                          )}
                          <div>
                            <MyModal
                              heading={
                                <span>
                                  API payload example{" "}
                                  <HelpButton helpKey="api-payload-example" />
                                </span>
                              }
                              size="lg"
                              label="Example payload"
                              buttonClassName="btn btn-colored btn-sm rounded-pill px-2"
                            >
                              <ProjectInputVariables uuid={t.CallUuid} />
                            </MyModal>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="alert alert-secondary">
                      No projects connected yet.
                    </div>
                  )}
                  <div className="mt-2">
                    {api.Uuid ? (
                      <LogicOpenAPI api={api} />
                    ) : (
                      <div className="alert alert-secondary">
                        Your API connection information will appear here once
                        you save the API.
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}

          {api.Kind === "messaging" && api.Messaging && (
            <>
              <div className="my-4">
                <div className="bg-purple-gradient-darker-reverse rounded-3 p-3">
                  <h5 className="">
                    Authentication credentials
                    <HelpButton helpKey="api-authentication-credentials" />
                  </h5>
                  {api.Messaging.Username ? (
                    <div className="mt-2">
                      <div>
                        <div>
                          <strong>Username:</strong>{" "}
                          <span style={{ userSelect: "all" }} className="ms-2">
                            {api.Messaging.Username}
                          </span>
                        </div>
                        <div className="">
                          <strong>Password:</strong>{" "}
                          {api.Messaging.Password ? (
                            <span
                              style={{ userSelect: "all" }}
                              className="ms-2"
                            >
                              {api.Messaging.Password}
                            </span>
                          ) : newPasswordData?.new_password ? (
                            <span
                              style={{ userSelect: "all" }}
                              className="ms-2"
                            >
                              {newPasswordData.new_password}
                            </span>
                          ) : (
                            <button
                              className="btn btn-link p-0 align-baseline ms-2"
                              onClick={async () => {
                                if (
                                  !(await confirmDialog(
                                    "Reset Messaging API password",
                                    `Are you sure you want to reset the password?`
                                  ))
                                ) {
                                  return;
                                }
                                const res = await resetMessagingPassword({
                                  apiConnectionUuid: api.Uuid,
                                });
                                if (res.data) {
                                  setNewPasswordData(res.data);
                                }
                                settingsProxyAPI.util.invalidateTags([
                                  "ApiConnections",
                                ]);
                              }}
                            >
                              Reset password
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  ) : (
                    "Your credentials will be available once you save this API."
                  )}
                </div>
              </div>

              <div className="my-4">
                <div className="bg-purple-gradient-darker-reverse rounded-4 p-3">
                  <h5>
                    Example request headers
                    <HelpButton helpKey="api-example-request-headers" />
                  </h5>
                  <div className="p-3 rounded-3 bg-secondary-subtle">
                    <pre className="mb-0">
                      <div>Content-Type: application/json </div>
                      <div className="pb-2">
                        Authorization: Basic{" "}
                        {api.Messaging.Username &&
                        (api.Messaging.Password ||
                          newPasswordData?.new_password) ? (
                          <em>
                            {btoa(
                              `${api.Messaging.Username}:${
                                api.Messaging.Password ||
                                newPasswordData?.new_password
                              }`
                            )}
                          </em>
                        ) : (
                          <em>your_auth_key</em>
                        )}
                      </div>
                    </pre>
                  </div>
                  <a
                    className="btn btn-secondary text-white mt-3 fw-bold"
                    href="https://app.swaggerhub.com/apis/BoomerangMessaging/boomerang-messaging_direct_api"
                    target="_blank"
                  >
                    Documentation on swaggerhub.com{" "}
                    <FontAwesomeIcon
                      icon={faArrowUpRightFromSquare}
                      className="ms-1"
                    />
                  </a>
                </div>
              </div>

              <div className="my-4">
                <div className="bg-purple-gradient-darker-reverse rounded-3 p-3">
                  <h5 className="">Default Dynamic Header</h5>
                  <div className="mt-2">
                    <Form.Control
                      placeholder="Enter default dynamic header"
                      value={api.Messaging.default_dynamic_header}
                      onChange={(e) => {
                        onChange({
                          ...api,
                          Messaging: {
                            ...api.Messaging,
                            default_dynamic_header: e.target.value,
                          },
                        });
                      }}
                    />
                    {api.Messaging.default_dynamic_header &&
                      !dynamicHeaderValid && (
                        <div className="text-danger mt-2">
                          Invalid dynamic header format.
                        </div>
                      )}
                    <div className="mt-2">
                      Dynamic Header must start with a letter, must contain
                      between 3 and 11 letters, numbers, spaces or _ (underscore
                      character)
                    </div>
                  </div>
                </div>
              </div>

              {pageProps.addOns.secure_data && (
                <div className="my-4">
                  <div className="bg-purple-gradient-darker-reverse rounded-4 p-3">
                    <h5>Secure data</h5>
                    <Form.Check
                      id="secure_data_checkbox"
                      type="checkbox"
                      label="Enable secure data overwrite"
                      checked={api.Messaging.use_secure_data || false}
                      onChange={(e) =>
                        onChange({
                          ...api,
                          Messaging: {
                            ...api.Messaging,
                            use_secure_data: e.target.checked,
                          },
                        })
                      }
                    />
                    <div className="p-3 rounded-3 bg-secondary-subtle mt-2">
                      Applicable to new messages. When option is active system
                      will replace message content and recipient with ###.
                      Option can be switched off anytime but once data is
                      overwritten it cannot be reversed. We strongly recommend
                      that you store the transaction id returned in the API
                      response, to track individual transactions.
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </Col>
      </Row>
    </div>
  );
}
